t = require('views/internal/teacup-with-helpers')('popover_card_from_calendar')

module.exports = ->
  t.div ->
    t.label ->
      t.format 'title'
    t.textarea '.js-card-title', ->
      t.text t.mustacheVar('title')

  t.div ->
    t.label ->
      t.format 'time'
    t.input '.datepicker-select-input.js-dpicker-time-input', {
      type: 'text',
      value: t.mustacheVar('dueTime')
    }

  t.div '.button-link.list-button-link.setting', ->
    t.span '.label', ->
      t.format 'list'
    t.span '.value.js-list-value'
    t.label ->
      t.format 'list'
    t.select '.js-select-list'

  t.div '.button-link.pos-button-link.setting', ->
    t.span '.label', ->
      t.format 'position'
    t.span '.value.js-pos-value'
    t.label ->
      t.format 'position'
    t.select '.js-select-position'

  t.input '.primary.wide.js-add-card', { type: 'submit', value: t.l('add') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_card_from_calendar.coffee